import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getPageLink } from 'helpers/resources';

import DropdownWrapper from '../DropdownWrapper';

const InsuranceNavGroup = () => {
  return (
    <DropdownWrapper>
      <LinkNav to={getPageLink('page-insurance-plans')} className="nav-link">
        Insurance
      </LinkNav>
      <div className="dropdown-menu insurance-dropdown-menu">
        <div className="dropdown-wrapper">
          <div className="dropdown-wrapper-col">
            <div className="dropdown-item title-item life-insurance">
              Life Insurance Plans
            </div>
            <div className="links-wrapper">
              <LinkNav
                to={getPageLink('page-term-90-plus-lp')}
                className="dropdown-item"
              >
                Term Insurance to Age 90
              </LinkNav>
              <LinkNav
                to={getPageLink('page-level-term-lp')}
                className="dropdown-item"
              >
                Level Term 10 or 20 Year Life Insurance
              </LinkNav>
              <LinkNav
                to={getPageLink('page-federal-civilian-term-90-plus-lp')}
                className="dropdown-item"
              >
                Federal Employee Term Life to Age 90
              </LinkNav>
              <LinkNav
                to={getPageLink('page-decreasing-group-lp')}
                className="dropdown-item"
              >
                Monthly Income Term Life Insurance
              </LinkNav>
              <LinkNav
                to={getPageLink('page-nexgen-child-lp')}
                className="dropdown-item"
              >
                Dependent Child Term Life Insurance
              </LinkNav>
              <LinkNav
                to={getPageLink('page-nexgen-adult-lp')}
                className="dropdown-item"
              >
                Adult Former MBA Dependent Life Insurance
              </LinkNav>
            </div>
          </div>
          <div className="dropdown-wrapper-col">
            <div className="dropdown-item title-item health-supplements">
              Health Insurance Supplements
            </div>
            <div className="links-wrapper">
              <LinkNav
                to={getPageLink('page-tricare-lp')}
                className="dropdown-item"
              >
                TRICARE Supplement Insurance
              </LinkNav>
              {/* <LinkNav
                to={getPageLink('page-hospitalinsurance-lp')}
                className="dropdown-item"
              >
                Hospital Indemnity Insurance
              </LinkNav> */}
            </div>

            <LinkNav
              to={'https://info.legalplans.com/9902237/sponsor'}
              className="dropdown-item title-item legal-services"
            >
              Legal Services
            </LinkNav>

            <LinkNav
              to={
                'https://www.libertymutual.com/mba?src=aff_4wpb_m_0115085_mba'
              }
              className="dropdown-item title-item auto-and-home-insurance"
            >
              Auto and Home Insurance
            </LinkNav>
          </div>
          <div className="dropdown-wrapper-col">
            <LinkNav
              to={getPageLink('page-pet-insurance-lp')}
              className="dropdown-item title-item pet-insurance"
            >
              <span className="highlighted">New!</span> Pet Insurance
            </LinkNav>
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default InsuranceNavGroup;
